import script from "./StatEmployeesTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./StatEmployeesTasks.vue?vue&type=script&setup=true&lang=js"

import "./StatEmployeesTasks.vue?vue&type=style&index=0&id=55e4db9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e4db9e"]])

export default __exports__